import { makeStyles, Theme, withStyles, createStyles } from '@material-ui/core/styles';
import { red, blue, orange, pink } from '@material-ui/core/colors';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    title: {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      fontSize: 18,
      color: 'black',
    },
    link: {
      cursor: 'pointer',
      marginRight: '5px',
      color: 'blue',
    },
    text: {
      marginLeft: '5px',
    },
    noLink: {
      cursor: 'pointer',
      textDecoration: 'none',
    },
    fixedHeight: {
      height: 240,
    },
    margin: {
      margin: theme.spacing(1),
    },
    select: {
      margin: theme.spacing(1),
      '& .MuiSelect-select:focus': {
        background: '#fff',
      },
    },
    search: {
      width: '50%',
    },
    box: {
      marginBottom: theme.spacing(2),
      width: '100%',
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: theme.spacing(1),
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
      },
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'space-between',
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        width: '100%',
        gap: theme.spacing(1),
      },
    },
    searchBar: {
      width: '380px',
    },
    noBorder: {
      border: 'none',
    },
    headerBtn: {
      boxShadow: 'none',
      textTransform: 'none',
      lineHeight: '36px',
      padding: `0 ${theme.spacing(3)}px`,
    },
    moreInfoBtn: {
      color: '#ff505f',
    },
    dateRangeButton: {
      width: 150,
      height: theme.spacing(4.5),
      fontSize: 14,
      textTransform: 'none',
      boxShadow: 'none',
      margin: theme.spacing(1),
      color: theme.palette.getContrastText(blue[500]),
      backgroundColor: blue[500],
      '&:hover': {
        backgroundColor: blue[700],
      },
    },
    dateRangePopUp: {
      position: 'absolute',
    },
    dataGrid: {
      width: '100%',
      overflowX: 'auto',
      '& .MuiDataGrid-root': {
        minWidth: '800px',
        [theme.breakpoints.down('md')]: {
          minWidth: '700px',
        },
        [theme.breakpoints.down('sm')]: {
          minWidth: '600px',
        },
        [theme.breakpoints.down('xs')]: {
          minWidth: '500px',
        },
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.8rem',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.75rem',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '0.7rem',
        },
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.75rem',
        },
      },
      '& .MuiDataGrid-cell': {
        [theme.breakpoints.down('md')]: {
          fontSize: '0.8rem',
          padding: '8px 6px',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.75rem',
          padding: '8px 4px',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '0.7rem',
          padding: '6px 2px',
        },
      },
      '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
      '& .row-background-error': {
        backgroundColor: red[50],
        '&:hover': {
          backgroundColor: red[100],
        },
      },
      '& .row-background-alert': {
        backgroundColor: pink[50],
        '&:hover': {
          backgroundColor: pink[100],
        },
      },
      '& .row-background-transaction': {
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .cell-text-color-error': {
        color: pink[700],
      },
      '& .cell-text-color-alert': {
        color: orange[700],
      },
      '& .cell-text-color-transaction': {
        color: 'black',
        fontWeight: '500',
        textTransform: 'capitalize',
      },
      '& .MuiDataGrid-colCellTitle': {
        color: 'black',
        fontWeight: '700',
        textTransform: 'capitalize',
      },
    },
    checkbox: {
      padding: theme.spacing(0, 1.5, 0, 0),
    },
  }),
  {
    index: 1,
  }
);

export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0.5, 0),
      },
    },
    input: {
      width: '200px',
      padding: '16px 16px',
      marginLeft: theme.spacing(1),
      borderRadius: 4,
      position: 'relative',
      background: '#fff',
      fontSize: 14,
      [theme.breakpoints.down('md')]: {
        width: '180px',
        padding: '14px 12px',
        fontSize: 13,
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: 0,
        padding: '12px 10px',
        fontSize: 12,
      },
      [theme.breakpoints.down('xs')]: {
        padding: '10px 8px',
        fontSize: 11,
      },
    },
  })
)(InputBase);
